import { render, staticRenderFns } from "./PracticePass.vue?vue&type=template&id=3cfdbd63&"
import script from "./PracticePass.vue?vue&type=script&lang=ts&"
export * from "./PracticePass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports